import { NavLink, useLocation } from "react-router-dom";
import { AccessibilityTab } from '@skillz/accessibility';
import classes from "./Menu.module.css";
import { removeSlashes } from "../../../utils/utils";


const Menu = ({ children, color, activeClass, colorSeclect, dropClass, dropClassLink, id }) => {

    const location = useLocation();

    const isBaseActive = (baseName) => {
        return baseName.includes(removeSlashes(location.pathname));
    }

    return (
        <div className={`${classes.Menu} ${dropClass}`} id={id}>

            {children.filter(t => t).map(tab =>
                <AccessibilityTab
                    id={tab.props.to}
                    selected={window.location.pathname.includes(tab.props.to)}
                    key={tab.props.to}
                >
                    <NavLink
                        to={tab.props.to}
                        // style={({ isActive }) => ({ color: isActive ? colorSeclect : color })}
                        className={({ isActive }) =>
                            `${classes.Tab} ${dropClassLink} 
                              ${((tab.props?.baseName && isBaseActive(tab.props.baseName)) || isActive) ? `${classes.Active} ${activeClass}` : ''}
                            `}
                    >
                        {tab.props.children}
                    </NavLink>

                </AccessibilityTab>
            )}
        </div>
    )
}
export default Menu;